// The shared external-link ("open in new window") glyph (S43): one inline SVG so status cells
// stop hand-rolling a literal arrow character. Inherits the surrounding link colour via
// currentColor; sized to sit beside the text-xs status pills. No icon library is installed in
// either package — keep this dependency-free.
export function ExternalLinkIcon({ size = 12, className }: ExternalLinkIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={className}
        >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <path d="M15 3h6v6" />
            <path d="M10 14 21 3" />
        </svg>
    );
}

export interface ExternalLinkIconProps {
    /** Square edge length in px; defaults to 12 to pair with text-xs pill labels. */
    size?: number;
    className?: string;
}
